import { useEffect, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import config from "./config";
import dayjs from "dayjs";
const Wrapper = ({ children }) => {
  const loginDetails = useSelector((state) => state.isLoggedIn);
  const billingExpiryDate = useSelector(
    (state) => state.shopDetails.billingExpiryDate
  );

  useLayoutEffect(() => {
    console.log("billingExpiryDate", billingExpiryDate);
    if (billingExpiryDate) {
      const toDate = dayjs(billingExpiryDate).toDate();
      if (toDate < new Date()) {
        Auth.signOut();
      }
    }
  }, [billingExpiryDate]);

  useEffect(() => {
    if (loginDetails) {
      var userType = window.localStorage.getItem("LOGIN_USERTYPE");
      if (
        userType !== "employee" ||
        !loginDetails.userType ||
        loginDetails.userType === "owner"
      ) {
        Auth.configure({
          Auth: {
            region: config.cognitoOwner.REGION,
            userPoolId: config.cognitoOwner.USER_POOL_ID,
            userPoolWebClientId: config.cognitoOwner.APP_CLIENT_ID,
            authenticationFlowType: "USER_PASSWORD_AUTH" | "USER_SRP_AUTH",
            // mandatorySignIn: false,
            // cookieStorage: {
            //   domain:
            //     process.env.NODE_ENV === "development"
            //       ? "localhost"
            //       : ".ghoshak.store", //localhost or .<domain>.com
            //   path: "/",
            //   expires: 30,
            //   sameSite: "none",
            //   secure: true,
            // },
          },
        });
      } else {
        Auth.configure({
          Auth: {
            region: config.cognitoEmployee.REGION,
            userPoolId: config.cognitoEmployee.USER_POOL_ID,
            userPoolWebClientId: config.cognitoEmployee.APP_CLIENT_ID,
            authenticationFlowType: "USER_PASSWORD_AUTH" | "USER_SRP_AUTH",
            mandatorySignIn: false,
            // cookieStorage: {
            //   domain: "ghoshak.store", //localhost or .<domain>.com
            //   path: "/",
            //   expires: 30,
            //   sameSite: "none",
            //   secure: true,
            // },
          },
        });
      }
    }
  }, [loginDetails]);
  return <>{children}</>;
};

export default Wrapper;
